// extracted by mini-css-extract-plugin
export default {"heroWrap":"Home_heroWrap__znOfL","tailDivider":"Home_tailDivider__DV+w8"};